import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'

import { getWorkerPerc } from './../amzn/worker'

class HeaderController extends RytmWebflow.Controller {
  
  constructor(id) {
    super(id)
  }
 /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    this.updateWorkcardPerc()
  }

  addEventListeners() {

  }
  removeEventListeners() {
    
  }


  /**
   * ###########
   * ### Own ###
   */
  async updateWorkcardPerc() {
    // first load from local storage
    const currentPerc = localStorage.getItem("workerPerc")
    this.setWorkerPercSpan(currentPerc ? currentPerc : 0)
    const perc = await getWorkerPerc()
    localStorage.setItem("workerPerc", perc)
    this.setWorkerPercSpan(perc, "animate")
  }
  setWorkerPercSpan(perc, className) {
    // trace("%% ", perc + "%")
    const wcPercSpan = document.querySelector('#workcard-perc')
    if (wcPercSpan) {
      if (className) {
        wcPercSpan.classList.add(className)
      }
      wcPercSpan.style.height = perc + "%"
    }
  }
  


}

export default HeaderController;